// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__-S0Qt","approved":"Status_approved__11LLM","rejected":"Status_rejected__2gbk9","expired":"Status_expired__19_Jl","label":"Status_label__36QXm"};